var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('v-card',[_c('v-form',{staticClass:"py-6 px-12"},[_c('v-row',_vm._l((_vm.AllFlags),function(flag){return _c('v-col',{key:flag.key,attrs:{"cols":"6"}},[_c('v-switch',{attrs:{"label":flag.label,"input-value":flag.value},on:{"change":(value) => _vm.updateFlag({[flag.key]: value})}})],1)}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }